import { ActivatedRouteSnapshot } from '@angular/router';

export function checkRouterChildsData(route: ActivatedRouteSnapshot, compareWith: (data) => boolean) {
  try {
    if (route?.data && compareWith(route.data)) {
      return true;
    }
  } catch {
    // Ignore any property access errors
  }

  if (!route?.firstChild) {
    return false;
  }

  return checkRouterChildsData(route.firstChild, compareWith);
}
